import { Injectable } from '@angular/core';
import { PosthogService } from '@examdojo/core/posthog';
import posthog from 'posthog-js';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PosthogFeatureFlagService {
  constructor() {
    if (PosthogService.canInitPosthog()) {
      posthog.onFeatureFlags(() => {
        this.isInitialized$$.next(true);
      });
    } else {
      this.isInitialized$$.next(true);
    }
  }

  private readonly isInitialized$$ = new BehaviorSubject(false);
  readonly isInitialized$ = this.isInitialized$$.asObservable();

  isFeatureEnabled(flag: string) {
    return posthog.isFeatureEnabled(flag);
  }

  getFeatureFlagPayload(flag: string) {
    return posthog.getFeatureFlagPayload(flag);
  }

  reloadFeatureFlags() {
    posthog.reloadFeatureFlags();
  }

  /**
   * Gets the variant value of a multivariate feature flag.
   *
   * Does not work with 'Release toggle' (boolean) feature flags.
   * @param flag
   */
  getMultivariateFeatureFlag(flag: string) {
    return posthog.getFeatureFlag(flag);
  }
}
